var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refund_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M19.7837 4.66687L19.1252 3.91429L19.7837 3.3381L20.4422 3.91429L19.7837 4.66687ZM5.68848 9.8752C5.68848 9.32292 6.13619 8.8752 6.68848 8.8752C7.24076 8.8752 7.68848 9.32292 7.68848 9.8752L5.68848 9.8752ZM13.1728 9.12263L19.1252 3.91429L20.4422 5.41945L14.4898 10.6278L13.1728 9.12263ZM20.4422 3.91429L26.3946 9.12263L25.0776 10.6278L19.1252 5.41945L20.4422 3.91429ZM20.7837 4.66687L20.7837 14.7859L18.7837 14.7859L18.7837 4.66687L20.7837 4.66687ZM5.68848 14.7859L5.68848 9.8752L7.68848 9.8752L7.68848 14.7859L5.68848 14.7859ZM13.2361 22.3335C9.06766 22.3335 5.68848 18.9544 5.68848 14.7859L7.68848 14.7859C7.68848 17.8498 10.1722 20.3335 13.2361 20.3335L13.2361 22.3335ZM20.7837 14.7859C20.7837 18.9543 17.4045 22.3335 13.2361 22.3335L13.2361 20.3335C16.3 20.3335 18.7837 17.8498 18.7837 14.7859L20.7837 14.7859Z",
    fill: "#36AB48",
    fillOpacity: 0.992712
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.a6d831c4c65830c574d9feb4369d7c84.svg";
export { ForwardRef as ReactComponent };